import requests from './httpService';

const StudentChargeMasterService = {
  list() {
    return requests.get('/studentchargemaster/list');
  },
  getApplicableFee(schooleId) {
    const qp = schooleId ? `?schooleId=${encodeURIComponent(String(schooleId))}` : '';
    return requests.get(`/studentchargemaster/applicable-fee${qp}`);
  },
  upsertGlobal(body) {
    return requests.post('/studentchargemaster/upsert?scope=global', body);
  },
  upsertSchool(body, schooleId) {
    const payload = { ...body };
    delete payload.schooleId;
    const qp = schooleId ? `?schooleId=${encodeURIComponent(String(schooleId))}` : '';
    return requests.post(`/studentchargemaster/upsert${qp}`, payload);
  },
  delete(id) {
    return requests.delete(`/studentchargemaster/${id}`);
  },
};

export default StudentChargeMasterService;
